import { Link } from '@inertiajs/react'
import { ChevronLeft } from 'lucide-react'
import { type ReactElement, type ReactNode } from 'react'

interface Props {
  title: string
  subtitle?: string
  backHref?: string
  backLabel?: string
  children?: ReactNode
}

export function PageHeader ({ title, subtitle, backHref, backLabel, children }: Props): ReactElement {
  return (
    <div className='flex items-start justify-between mb-7 gap-4'>
      <div className='flex-1'>
        {(backHref != null && backHref !== '') && (
          <Link
            href={backHref}
            className='inline-flex items-center gap-1.25 text-xs text-(--bp-ink3) mb-2 no-underline cursor-pointer hover:text-(--bp-accent)'
          >
            <ChevronLeft width={14} height={14} />
            {backLabel}
          </Link>
        )}
        <div className='text-[22px] font-bold tracking-[-0.04em] text-(--bp-ink)'>{title}</div>
        {(subtitle != null && subtitle !== '') && <div className='text-[13px] text-(--bp-ink3) mt-1'>{subtitle}</div>}
      </div>
      {children != null && <div className='flex gap-2 items-center shrink-0'>{children}</div>}
    </div>
  )
}
